
const ResumeUploadAction = {
  LOADING: 'LOADING',
  RESUME_UPLOADING: 'RESUME_UPLOADING',
  UPLOAD_RESUME_SUCCESS: 'UPLOAD_RESUME_SUCCESS',
  UPLOAD_RESUME_FAIL: 'UPLOAD_RESUME_FAIL',
  SHOW_RESUME_UPLOAD: 'SHOW_RESUME_UPLOAD',
  FETCH_RESUME_INFO_SUCCESS: 'FETCH_RESUME_INFO_SUCCESS',
  FETCH_RESUME_INFO_FAIL: 'FETCH_RESUME_INFO_FAIL',
  FETCH_RESUME_PARSED_DATA_SUCCESS: 'FETCH_RESUME_PARSED_DATA_SUCCESS',
  FETCH_RESUME_PARSED_DATA_FAIL: 'FETCH_RESUME_PARSED_DATA_FAIL',
  RESUME_MODAL_SKIP: 'RESUME_MODAL_SKIP',
  DISPATCH_RESUME_PREVIEW: 'DISPATCH_RESUME_PREVIEW',
  ISRESUME_UPLOADING: 'ISRESUME_UPLOADING',
  SAVE_RESUME_FILE: 'SAVE_RESUME_FILE',
  RESET_DATA: 'RESET_DATA',
  SYNC_LINKEDIN_FAIL: 'SYNC_LINKEDIN_FAIL',
  SYNC_LINKEDIN_SUCCESS: 'SYNC_LINKEDIN_SUCCESS',
  LINKEDIN_SYNCED_DATA_SUCCESS: 'LINKED_IN_SYNCED_DATA_SUCCESS',
  URL_ERROR: 'URL_ERROR',
  SET_LINKEDIN_URL: 'SET_LINKEDIN_URL'
};

export {
  ResumeUploadAction
};
